<template>

  <div class="modal" tabindex="-1" role="dialog" id="modalcitorec">
    <div class="modal-dialog" role="document" style="min-width:760px">
      <div class="modal-content" style="width:780px">
        <div class="modal-header">
          <h5 class="modal-title text-center"> <b> Recibo del Pago </b> </h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close"> <span aria-hidden="true">&times;</span> </button>
        </div>
        <div class="modal-body text-center">
          <p v-show="cargando" class="text-center text-primary">Cargando datos...</p>
          <canvas id="myCanvas" width="720" height="600" style="border:1px solid #55d3d3d3;">
          </canvas>
          <p v-show="cargando" class="text-center text-primary">Cargando datos...</p>

          <button :disabled="cargando" class="btn btn-sm btn-success" @click="guardar()"> Descargar recibo en PDF </button>
          <a href="" id="link"></a>
          <div id="qrcode"></div>
        </div>

        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-dismiss="modal">Cerrar</button>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
export default {
  props:{ model:{type:Object,required:true} }, //{pago,estudiante}
  data(){
    return{
      cargando: false,
      image: null,
    }
  },
  watch:{
    'model.pago':function(){
      var vue = this;
      //this.cargando = true;
      // window.console.log("JJAJAJAJA", window.stringifyObject(this.model) )
      vue.cargarCanvas()
      vue.cargando = false;
    }
  },
  methods:{
    parseEst(){
      if( !this.model ) return "NUL"
      var es = this.model.estudiante;
      if( !es ) return "NULO"
      var am = es.seg_apellido?es.seg_apellido:"";
      return es.nombres+" "+es.pri_apellido+" "+am;
    },
    parseAse(){
      if( !this.model ) return "NUL"
      var es = this.model.asesor;
      if( !es ) return "NULO"
      var am = es.seg_apellido?es.seg_apellido:"";
      return es.nombres+" "+es.pri_apellido+" "+am;
    },
    parseCarnet(){
      if( !this.model ) return "NUL"
      var es = this.model.estudiante;
      if( !es ) return "NULO"
      // window.console.log('CerrecibopagonewIns.vue line 68', es);
      let dep = es && es.departamento ? es.departamento.extension :'';
      return es.num_doc+' '+ dep;
    },
    parseTelefono(){
      if( !this.model ) return "NUL"
      var es = this.model.estudiante;
      if( !es ) return "NULO"
      return es.telefono1;
    },
    parseCargaHoraria(){
      if( this.model.inscripcion == null ) return "1";
      if( this.model.inscripcion.programa == null ) return "2";
      if( this.model.inscripcion.programa.postgrado == null ) return "3";
      var post = this.model.inscripcion.programa.postgrado;
      return post.carga_horaria;
    },
    parseSedeCiudad(){
      if( this.model.inscripcion == null ) return "1";
      if( this.model.inscripcion.programa == null ) return "2";
      if( this.model.inscripcion.programa.sede == null ) return "3";
      var sede = this.model.inscripcion.programa.sede.ciudad;
      return sede.nombre;
    },
    parseProgram(){
      if( this.model.inscripcion == null ) return "1";
      if( this.model.inscripcion.programa == null ) return "2";
      if( this.model.inscripcion.programa.postgrado == null ) return "3";
      var post = this.model.inscripcion.programa.postgrado;
      var nom = post.nombre.toUpperCase();
      nom = nom.replace("CURSO EN","")
      nom = nom.replace("CURSO ","")
      nom = nom.replace("CURSO ","")
      nom = nom.replace("CURSO EN","")
      nom = nom.replace("DIPLOMADO ","")
      nom = nom.replace("DIPLOMADO EN ","")
      nom = nom.replace("ESPECIALIDAD ","")
      nom = nom.replace("ESPECIALIDAD EN ","")
      nom = nom.replace("MAESTRIA EN ","")
      nom = nom.replace("MAESTRIA ","")
      return nom;
    },
    parseMes( m ){
      m = m-1;
      if( m == 0 ) return "Enero"
      else if( m == 1 ) return "Febrero"
      else if( m == 2 ) return "Marzo"
      else if( m == 3 ) return "Abril"
      else if( m == 4 ) return "Mayo"
      else if( m == 5 ) return "Junio"
      else if( m == 6 ) return "Julio"
      else if( m == 7 ) return "Agosto"
      else if( m == 8 ) return "Septiembre"
      else if( m == 9 ) return "Octubre"
      else if( m == 10 ) return "Noviembre"
      else if( m == 11 ) return "Diciembre"
    },
    parseFecha( f ){
      if( f == null ) return "";
      var fs = f.split('-');
      return fs[2]+"/"+fs[1]+"/"+fs[0];
    },

    cargarCanvas(){
      var estudiante = this.parseEst();
      var asesor = this.parseAse();
      var carnet = this.parseCarnet();
      var telefo = this.parseTelefono();
      var tipop = this.model.pago.tipo_pago?'Al credito':'Al contado';
      var monto = this.model.pago.monto;
      var nrecibo = this.model.pago.nro_recibo;
      var saldo = this.model.pago.saldo - monto;
      var nro_cuota = this.model.pago.cuota.nro_cuota;
      var c = document.getElementById("myCanvas");
      var ctx = c.getContext("2d");
     
      ctx.drawImage(this.image, 0, 0, 720, 600);

      var fecha = this.model.pago.fecha_pago;
      var fecha_prox = '--'
      try{
        fecha_prox = "01-01-01";
      }catch(e){ window.console.error(e)}

      if( !fecha ) fecha = "01-01-01";
      if( !fecha_prox ) fecha_prox = "--";

      var ds = fecha.split("-");
      var dia = ds[2];
      var year = ds[0];
      var mes = ds[1];

      var dsprox= fecha_prox.split("-");
      var diap = dsprox[2];
      var yearp = dsprox[0];
      var mesp = dsprox[1];
      var fec_prox = diap+'/'+mesp+'/'+yearp;

      ctx.font = "15px Arial";
      ctx.textAlign = "center";
      ctx.fillText(""+estudiante, (c.width/2)-40, 293);
      // ctx.fillText(""+asesor, (c.width/2)-100, 470);
      ctx.fillText(''+asesor, c.width / 2 - 180, 548);      
      ctx.fillText(""+carnet, (c.width/2)+250, 293);
      ctx.fillText(""+telefo, (c.width/2)+280, 335);
      ctx.fillText("Pago de primera cuota", (c.width/2)-150, 370);
      ctx.fillText(""+tipop, (c.width/2)-190, 407);
      ctx.fillText(""+monto+" Bs.", (c.width/2)-270, 440);
      ctx.fillText(""+saldo+" Bs.", (c.width/2)-70, 440);
      ctx.fillText(""+nro_cuota, (c.width/2)+90, 440);
      ctx.fillText(""+monto, (c.width/2)+260, 185);
      ctx.fillText("--------", (c.width/2)+260, 220);
      ctx.font = "14px Arial";
      ctx.fillText(""+dia, (c.width/2)-200, 210);
      ctx.fillText(""+mes, (c.width/2)-155, 210);
      ctx.fillText(""+year, (c.width/2)-115, 210);
      ctx.font = "22px Arial";
      ctx.fillText(""+nrecibo, (c.width/2)-0, 210);
      ctx.font = "15px Arial";

      ctx.fillText(""+fec_prox, (c.width/2)+280, 440);
    },
    getDatos(){
      var xins = sessionStorage.xxinscripcion;
      this.model.inscripcion =JSON.parse( xins );
      window.console.log( window.stringifyObject(this.model.inscripcion) )
      this.cargarCanvas();
    },
    guardar(){
      var canvas = document.getElementById("myCanvas");
      let width = canvas.width; 
      let height = canvas.height;
      var pdf;
      var nombre = this.parseEst();

      if(width > height){
        pdf = new window.jsPDF('l', 'px', [width, height]);
      }
      else{
        pdf = new window.jsPDF('p', 'px', [height, width]);
      }

      width = pdf.internal.pageSize.getWidth();
      height = pdf.internal.pageSize.getHeight();
      pdf.addImage(canvas, 'PNG', 0, 0,width,height);
      pdf.save( nombre+".pdf");
    }
  },
  mounted(){
    let sede = this.$store.state.CARGO.sede;
    if (sede.modelo_recibo) {
      this.image = new Image();
      this.image.src = process.env.VUE_APP_URL_BG_RECIBO_SEDE + sede.modelo_recibo;
    } else {
      this.$root.$notify.show('La Sede No tiene Un fondo definido', {color:'red', timeout: 10000})
    }
    var vue =this;

    window.$('#modalrecibo').on('hidden.bs.modal', function () {
      vue.model.pago = {};
    })
    
  }
}
</script>